import _ from 'lodash';
import Cookies from 'js-cookie';
import { mapGetters } from 'vuex';
import { Common } from '@src/common';
import route from '@src/router';
import { exceptHandler } from '@action/util';
import { getLogin } from '@api/auth';
import videoData from '@api/video';
import { IGenericObject } from '@typings';

const videoApi: IGenericObject<any> = videoData;
const data = {
  role_code: '',
  feature: {},
};

export default {
  computed: {
    ...mapGetters(['getUserDevices']),
  },
  data() {
    return {
      user_access_type: undefined,
    };
  },
  created() {
    this.dataInit();
  },
  methods: {
    dataInit() {
      const router = route.currentRoute;

      if (!router.query?.access_type) {
        this.user_access_type = sessionStorage.getItem('access_type');
      } else {
        this.user_access_type = router.query.access_type;
      }

      if (this.user_access_type === 'app') {
        const userData = {
          username: router.query.username,
          password: router.query.password,
          role_code: router.query.role_code,
          device_id: router.query.device_id,
          lang: router.query.lang,
          grant_type: 'password',
        };

        if (Cookies.get(Common.STORAGE_LANG) === undefined) {
          Cookies.set(Common.STORAGE_LANG, userData.lang);
        }

        this.setAppData(userData);
      } else {
        this.setWebData();
      }

      data.role_code = sessionStorage.role_code;
      data.feature = videoApi.feature;
    },
    async setAppData(userData) {
      try {
        const userInfo = await this.getUserInfo(userData);
        sessionStorage.accessToken = `Bearer ${userInfo.accessToken}`;
        sessionStorage.user_info = JSON.stringify(userInfo);
        sessionStorage.role_code = userInfo.user.role_code;
        sessionStorage.setItem('access_type', 'app');
        const fetchDevices = await this.$store.dispatch('FETCH_USER_DEVICES');
        this.deviceCallback(fetchDevices.data.items);
        this.data.isAccess = true;
      } catch (err) {
        exceptHandler(err);
      }
    },
    async setWebData() {
      this.data.product_type_id = videoApi.data.product_type_id;

      if (!sessionStorage.accessToken) {
        window.location.href = `${window.location.origin}/auth/login`;
        this.data.isAccess = false;
      } else {
        const fetchDevices = await this.$store.dispatch('FETCH_USER_DEVICES');
        this.deviceCallback(fetchDevices.data.items);
        this.data.isAccess = true;
      }
    },
    async getUserInfo(userData) {
      const response = await getLogin(userData);
      return response.data.items;
    },
    deviceCallback(arr) {
      const deviceCheck = route.currentRoute.query.device_id;
      let idx = 0;

      if (deviceCheck) {
        for (idx = 0; idx < _.size(arr); idx += 1) {
          if (arr[idx].id === +deviceCheck) {
            videoApi.feature = arr[idx].feature;
            videoApi.data.product_type_id = arr[idx].product_type_id;
            videoApi.product_type_info = arr[idx].product_type_info;
            videoApi.role_code = arr[idx].user_role_code;
            videoApi.user_id = arr[idx].user_id;

            this.isGetDevice = true;
          }
        }

        this.data.product_type_id = videoApi.data.product_type_id;
        this.data.feature = videoApi.feature;
      } else {
        const obj = _.find(arr, (item) => item.user_role_code !== '12006');
        this.data.product_type_id = obj.product_type_id;
        this.data.feature = obj.feature;
      }
      this.data.featureStatus = this.getFeatureStatus(this.data.feature);

      this.data.access_type = this.user_access_type;
      this.userInfoCallback(this.data);
    },
    getFeatureStatus({ text_animation: textAnimation }) {
      const featureStatus = { mov: false };

      if (textAnimation === 'Y') {
        featureStatus.mov = true;
      }

      return featureStatus;
    },
  },
};
